import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import TrendResearchDoughnutChart from '@features/trend-research/components/common/TrendResearchDoughnutChart';
import useQueryString from '@features/trend-research/hooks/useQueryString';
import { sourceType } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findColorGraphicsSummary } from '@services/trendResearch';

const Charts = () => {
	const dispatch = useDispatch();
	const [dataFromDatabase, setDataFromDatabase] = useState({});
	//const sourceType = useExploreProductsSource();
	const queryString = useQueryString();
	const location = useLocation();
	const { source } = location?.state || {};

	const getData = async () => {
		try {
			if (!queryString || queryString.trim() === '') {
				return;
			}

			const searchParams = new URLSearchParams(queryString);
			if (searchParams.has('colorList')) {
				searchParams.delete('colorList');
			}
			if (searchParams.has('graphicsContentList')) {
				searchParams.delete('graphicsContentList');
			}
			const updatedQueryString = `?${searchParams.toString()}`;
			const data = await findColorGraphicsSummary(sourceType[source], updatedQueryString);
			setDataFromDatabase(data);
		} catch {
			/* Empty Block */
		}
	};

	useEffect(() => {
		if (!queryString || queryString.trim() === '') {
			return;
		}
		(async () => {
			dispatch(openLoader());
			getData();
			dispatch(closeLoader());
		})();
	}, [queryString]);

	return (
		<div className="chart-and-graph-section">
			{/* <div className="section-title pb-3 d-flex align-items-center justify-content-between">
				<p className="regular-16 weight-500 gray_dark_01">Product Information</p>
			</div> */}
			<div className="chart-graph-grid fabric-chart-graph-grid pb-3">
				<TrendResearchDoughnutChart
					title={'Solid, Graphics, AOP, Wash'}
					dataSet={dataFromDatabase.graphicsTypeWisePercentageMap}
				/>

				<TrendResearchDoughnutChart
					title="Top Solid Color"
					dataSet={dataFromDatabase.colorWisePercentageMap}
				/>
			</div>
		</div>
	);
};

export default Charts;
